import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Toaster
      position="top-center"
      reverseOrder={false}
      containerClassName="instantDigitsToastContainer"
      toastOptions={{
        style: {
          // per-toast style, keep it simple
          borderRadius: "999px",
        },
      }}
    />
    <App />
  </React.StrictMode>
);

reportWebVitals();
